import { call, put } from 'redux-saga/effects';
import { createGopUploadWithFile, fetchDataByContext } from "../../api/strapiGop";
import { FetchCommentByContextRequestAction, UploadFileRequestAction } from "../../types/types";
import { fetchCommentByContextFailure, fetchCommentByContextSuccess, uploadFileFailure, uploadFileSuccess } from './actions';
import { fetchData } from '../../actions/actions';

export function* uploadFileSaga(action: UploadFileRequestAction) {
  const { file, refId, title } = action.payload;

  try {
    const result = yield call(createGopUploadWithFile, file, refId, title);
    yield put(uploadFileSuccess(result));
    yield put(fetchData('gop-uploads'));
  } catch (error) {
    const errorMessage = (error as any)?.response?.data?.error?.message || (error as any)?.message || 'Ошибка загрузки файла';
    yield put(uploadFileFailure(errorMessage));
  }
}

//! поиск действия для главной по context
export function* fetchCommentByContextSaga(action: FetchCommentByContextRequestAction) {
  try {
    const { modelName, context } = action.payload;
  const gopComments: any[] = yield call(fetchDataByContext, modelName, context);
    // console.log('gopComments', gopComments);
    yield put(fetchCommentByContextSuccess(gopComments));
  } catch (error: any) {
    const errorMessage = error?.message || 'Ошибка при поиске комментариев';
    yield put(fetchCommentByContextFailure(errorMessage));
  }
}